import { useEffect, useState } from "react";
import { Pencil, Trash2, Check, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PageTitle } from "@/pages/admin/AdminLayout";

export default function Brands() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/admin/brands").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const act = (fn, ok) => async (e) => { e?.preventDefault(); try { await fn(); toast.success(ok); load(); } catch (e2) { toast.error(errMsg(e2)); } };
  const create = act(async () => { await api.post("/admin/brands", { name }); setName(""); }, "Marca criada");
  return (
    <div data-testid="admin-brands">
      <PageTitle title="Marcas" sub="Só é possível eliminar marcas sem relógios associados." />
      <form onSubmit={create} className="flex gap-3 mb-6 max-w-md">
        <input className="afield" placeholder="Nova marca" value={name} onChange={(e) => setName(e.target.value)} data-testid="brand-new-input" />
        <button className="btn-gold !py-2" disabled={!name.trim()} data-testid="brand-create-button">Criar</button>
      </form>
      <div className="border border-[#282520] divide-y divide-[#282520] max-w-2xl">
        {items.map((b) => (
          <div key={b.id} className="flex items-center gap-3 px-4 py-3" data-testid={`brand-row-${b.slug}`}>
            {edit?.id === b.id ? (
              <>
                <input className="afield flex-1" value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} data-testid="brand-edit-input" autoFocus />
                <button onClick={act(async () => { await api.put(`/admin/brands/${b.id}`, { name: edit.name }); setEdit(null); }, "Marca atualizada")} className="p-2 text-[#9fc79a]" aria-label="Guardar" data-testid="brand-edit-save"><Check className="w-4 h-4" /></button>
                <button onClick={() => setEdit(null)} className="p-2 text-[#A39E93]" aria-label="Cancelar"><X className="w-4 h-4" /></button>
              </>
            ) : (
              <>
                <span className="flex-1">{b.name}</span>
                <span className="text-xs text-[#A39E93]">{b.watch_count} relógio(s)</span>
                <button onClick={() => setEdit({ id: b.id, name: b.name })} className="p-2 text-[#A39E93] hover:text-[#E6D5AC]" aria-label="Editar" data-testid={`brand-edit-${b.slug}`}><Pencil className="w-4 h-4" /></button>
                <button onClick={act(() => api.delete(`/admin/brands/${b.id}`), "Marca eliminada")} className="p-2 text-[#A39E93] hover:text-[#e0937f]" aria-label="Eliminar" data-testid={`brand-delete-${b.slug}`}><Trash2 className="w-4 h-4" /></button>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
